import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import React from "react";
import { GridTable } from "../Sidebar/SidebarStyles";
import { ActiveateOrDeactivateCsrUserConfig, AddCsrUserConfig, AddCsrUserConfigInterface, DeleteCsrUserConfig, GetAllCsrUserConfig, getbroker } from "../ApiSevices/UserMasterApis";
import { AddQuestionConfigReferanceMapping, GetAllQuestionConfigReferanceMapping, UpdateReferenceBrokerId } from "../ApiSevices/QuestionConfigService";
import SnackBarComponent from "../Common/SnackBarComponent";
import { Cancel, Delete, Edit } from "@mui/icons-material";
import CheckIcon from '@mui/icons-material/Check';
import { green, red } from "@mui/material/colors";
import ConfirmationDialogComponent from "../Common/ConfirmationDialogComponent";

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    loading: boolean,
    datas: any[],
    pageNo: number,
    pageSize: number,
    selectedBrokerId: number,
    totalRecords: number,
    brokerMaster: any[],
    referenceBrokerMaster: any[],
    isDialogOpen: boolean,
    dialogData: {
        isAdd: boolean,
        referenceFor: number,
        referenceTo: number
    },
    snackBar: {
        message: string;
        severity: 'error' | 'warning' | 'info' | 'success';
        open: boolean;
        onClose: () => void
    },
    confirmationDialog: {
        isOpen: boolean,
        recordId: number,
        message: string,
        activate: boolean,
        isDelete?: boolean
    }
}

const columns: any[] = [
    { field: 'Id', headerName: 'Id', width: 70 },
    { field: 'BrokerId', headerName: 'BrokerId', width: 350 },
    { field: 'BrokerName', headerName: 'Broker Name', width: 350 },
    { field: 'IsActive', headerName: 'Status', width: 100 },
    { field: 'CreatedOn', headerName: 'CreatedOn', width: 100 },
    { field: 'Action', headerName: 'Action', width: 100 },
];

class PrimarySecondaryUserConfig extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            datas: [],
            pageNo: 1,
            pageSize: 1000,
            selectedBrokerId: 0,
            totalRecords: 0,
            brokerMaster: [],
            referenceBrokerMaster: [],
            isDialogOpen: false,
            dialogData: {
                isAdd: false,
                referenceFor: 0,
                referenceTo: 0
            },
            snackBar: {
                message: "",
                severity: 'success',
                open: false,
                onClose: () => { }
            },
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false
            }
        }
    }

    async componentDidMount(): Promise<void> {
        try {
            this.setState({ loading: true });
            const [brokerResponse, referenceMappingData] = await Promise.all([
                getbroker(), GetAllCsrUserConfig()
            ]);

            const sortResArray = brokerResponse?.sort((a: any, b: any) => a?.vchBrokerName.localeCompare(b?.vchBrokerName))
            let brokerMasterAltered1 = sortResArray?.map((e: any) => { return { label: e?.vchBrokerName, value: e?.Broker_ID } });
            brokerMasterAltered1 = brokerMasterAltered1?.filter((f: any) => f?.value !== 0);

            this.setState({
                brokerMaster: brokerMasterAltered1,
                referenceBrokerMaster: brokerMasterAltered1,
                datas: referenceMappingData?.data || [],
                totalRecords: referenceMappingData?.data?.length || 0
            });

        } catch (error) {
            console.error("Error in componentDidMount:", error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async getData(): Promise<void> {
        this.setState({ loading: true });
        try {
            const { pageNo, pageSize, selectedBrokerId } = this.state;
            const response = await GetAllQuestionConfigReferanceMapping(pageNo, pageSize, selectedBrokerId);
            this.setState({
                datas: response?.data || [],
                totalRecords: response?.total_count || 0
            });
        } catch (error) {
            console.error("Error in getData:", error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false,
            dialogData: {
                isAdd: false,
                referenceFor: 0,
                referenceTo: 0
            }
        });
    };

    handleDialogConfirm = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            if (this.state.dialogData.isAdd) {
                await AddQuestionConfigReferanceMapping(this.state.dialogData.referenceFor, this.state.dialogData.referenceTo);
            } else {
                await UpdateReferenceBrokerId(this.state.dialogData.referenceFor, this.state.dialogData.referenceTo);
            }
            this.setState({
                isDialogOpen: false
            });
            await this.getData();
        }
        catch (e: any) {
            if (e?.name === "AxiosError") {
                if (e?.response?.data?.detail?.includes("Active mapping exists") || e?.response?.data?.detail?.includes("combination already exists")) {
                    this.setState({ snackBar: { message: e?.response?.data?.detail, severity: 'warning', open: true, onClose: () => { } } });
                } else {
                    this.setState({ snackBar: { message: "Something went wrong!", severity: 'warning', open: true, onClose: () => { } } });
                }
            }
        }
        finally {
            this.setState({ loading: false });
        }
    };

    onConfirmationDialog = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            if (this.state.confirmationDialog.isDelete) {
                await DeleteCsrUserConfig(this.state.confirmationDialog.recordId);
            }
            else {
                await ActiveateOrDeactivateCsrUserConfig(this.state.confirmationDialog.recordId, this.state.confirmationDialog.activate);
            }
            await this.updateTableData();
            this.setState({
                confirmationDialog: {
                    isOpen: false,
                    recordId: 0,
                    message: "",
                    activate: false,
                    isDelete: false
                }
            });
        } catch (e) {
            this.setState({ snackBar: { message: "Something went wrong!", severity: 'warning', open: true, onClose: () => { } } });
        }
        finally {
            this.setState({ loading: false });
        }
    }

    updateTableData = async () => {
        this.setState({ loading: true });
        try {
            const [referenceMappingData] = await Promise.all([
                GetAllCsrUserConfig()
            ]);
            this.setState({
                datas: referenceMappingData?.data || [],
                totalRecords: referenceMappingData?.data.length || 0
            })
        } finally {
            this.setState({ loading: false });
        }
    }

    OnAddClick = async () => {
        const { selectedBrokerId, brokerMaster } = this.state;
        this.setState({ loading: true });
        try {
            const body: AddCsrUserConfigInterface = {
                id: 0,
                brokerId: selectedBrokerId,
                brokerName: brokerMaster.find((e: any) => e.value === selectedBrokerId)?.label || '',
                userName: "",
                createdBy: "",
                isActive: true
            }
            const response = await AddCsrUserConfig(body);
            if (response?.status === 200) {
                this.setState({ snackBar: { message: "Broker added successfully!", severity: 'success', open: true, onClose: () => { } } });
                this.updateTableData();
            }
        } catch (exception) {
            this.setState({ snackBar: { message: "Something went wrong!", severity: 'warning', open: true, onClose: () => { } } });
        } finally {
            this.setState({ loading: false, selectedBrokerId: 0 });
        }
    }

    render() {
        const { loading, brokerMaster, selectedBrokerId, datas, isDialogOpen, dialogData, referenceBrokerMaster, snackBar, confirmationDialog } = this.state;
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '90vh' }} displaysidebar={this?.props?.displaysidebar}>
                    <p><b>Primary And Secondary User Configuration</b></p><br />
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%"
                    }}>
                        <div style={{ flex: "1 1 150px", maxWidth: "250px" }}>
                            <Autocomplete
                                options={brokerMaster.filter(e=> !datas?.map(e=>e.BrokerId)?.includes(e?.value))}
                                getOptionLabel={(option) => option?.label || ''}
                                value={brokerMaster.find((e: any) => e.value === selectedBrokerId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedBrokerId: newValue?.value || 0 });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Broker..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                        </div>
                        <button
                            style={{
                                height: "25px",
                                padding: "0 20px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "12px"
                            }}
                            onClick={() => {
                                this.OnAddClick()
                            }}
                            disabled={!selectedBrokerId || selectedBrokerId === 0}
                        >
                            Add
                        </button>
                    </div> <br />
                    <div>
                        <Paper sx={{ width: '100%', mb: 2, border: '0.5px solid #7a6e6e54', maxHeight: '60vh' }}>
                            <TableContainer sx={{ maxHeight: 400, overflow: 'auto', paddingBottom: '80px' }}> {/* Enable scrolling */}
                                <Table stickyHeader sx={{ height: '50px' }} size="small">
                                    {/* Table Header */}
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.field}
                                                    sx={{
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        whiteSpace: 'nowrap',
                                                        backgroundColor: '#f5f5f5',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    {column.headerName}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    {/* Table Body */}
                                    <TableBody>
                                        {datas && Array?.isArray(datas) && datas?.length > 0 &&
                                            datas?.map((row, rowIndex) => (
                                                <TableRow key={row.Id}>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.field}
                                                            sx={{
                                                                fontSize: '10px',
                                                                whiteSpace: 'normal',
                                                                wordWrap: 'break-word',
                                                                lineHeight: '1.5',
                                                            }}
                                                        >
                                                            {column.field === 'Action' ?
                                                                (
                                                                    <>
                                                                        {
                                                                            row.IsActive ?
                                                                                <Cancel fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                    this.setState({
                                                                                        confirmationDialog: {
                                                                                            isOpen: true,
                                                                                            recordId: row.Id,
                                                                                            message: `Are you Sure you want to deactivate this record of Id: ${row?.Id}?`,
                                                                                            activate: false
                                                                                        }
                                                                                    });
                                                                                }} style={{ color: red[500] }} />
                                                                                :
                                                                                <CheckIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                    this.setState({
                                                                                        confirmationDialog: {
                                                                                            isOpen: true,
                                                                                            recordId: row.Id,
                                                                                            message: `Are you Sure you want to activate this record of Id: ${row?.Id}?`,
                                                                                            activate: true
                                                                                        }
                                                                                    });
                                                                                }} style={{ color: green[500] }} />
                                                                        }
                                                                        &nbsp;
                                                                        <Delete fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                            this.setState({
                                                                                confirmationDialog: {
                                                                                    isOpen: true,
                                                                                    recordId: row?.Id,
                                                                                    message: `Are you Sure you want to delete this record of Id: ${row?.Id}?`,
                                                                                    activate: false,
                                                                                    isDelete: true
                                                                                }
                                                                            });
                                                                        }} />
                                                                    </>
                                                                )
                                                                :
                                                                column.field === 'IsActive' ?
                                                                    (row[column.field] ? "Active" : "Inactive") :
                                                                    column.field === 'CreatedOn' && row[column.field] ? new Date(row[column.field]).toLocaleDateString() :
                                                                        row[column.field]
                                                            }
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </div>
                    <div>
                        <Dialog open={isDialogOpen} onClose={(e) => { }} fullWidth maxWidth="md">
                            <DialogTitle>{dialogData?.isAdd ? "Add New Reference Broker Config" : "Edit Reference Broker Config"}</DialogTitle>
                            <DialogContent>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                    <p>Reference For</p>
                                    <Autocomplete
                                        options={brokerMaster}
                                        readOnly={!dialogData?.isAdd}
                                        getOptionLabel={(option) => option?.label || ''}
                                        value={brokerMaster.find((e: any) => e.value === dialogData?.referenceFor) || null}
                                        onChange={(event, newValue) => {
                                            dialogData.referenceFor = newValue?.value || 0;
                                            this.setState({ dialogData: dialogData });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Select Broker..."
                                                size="medium"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { height: 25, fontSize: "11px" }
                                                }}
                                            />
                                        )}
                                        fullWidth
                                        slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                    />
                                    <p>Reference To</p>
                                    <Autocomplete
                                        options={referenceBrokerMaster}
                                        getOptionLabel={(option) => option?.label || ''}
                                        value={referenceBrokerMaster.find((e: any) => e.value === dialogData?.referenceTo) || null}
                                        onChange={(event, newValue) => {
                                            dialogData.referenceTo = newValue?.value || 0;
                                            this.setState({ dialogData: dialogData });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Select Broker..."
                                                size="medium"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { height: 25, fontSize: "11px" }
                                                }}
                                            />
                                        )}
                                        fullWidth
                                        slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                    />
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleDialogClose} color="secondary">
                                    Cancel
                                </Button>
                                <Button
                                    onClick={this.handleDialogConfirm}
                                    color="primary"
                                    disabled={!(dialogData?.referenceFor && dialogData?.referenceFor > 0 && dialogData?.referenceTo && dialogData?.referenceTo > 0 && dialogData?.referenceFor !== dialogData?.referenceTo)}
                                >
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    <div>
                        <SnackBarComponent open={snackBar.open} message={snackBar.message} severity={snackBar.severity} onClose={() => {
                            this.setState({
                                snackBar: {
                                    ...this.state.snackBar,
                                    open: false,
                                    message: ''
                                }
                            });
                        }} />
                        <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                            this.setState({
                                confirmationDialog: {
                                    isOpen: false,
                                    recordId: 0,
                                    message: "",
                                    activate: false,
                                    isDelete: false
                                }
                            });
                        }} />
                    </div>
                </GridTable>
            </div>
        );
    }
}

export default PrimarySecondaryUserConfig;